<template>
    <div class="listing-content wishlist_custom">
        <div v-for="(section, index) in displayedSections" :key="index">
            <div class="listing-products">
                <div class="item_wishlist" v-for="(item, i) in section.items" :key="item.product_id">
                    <div class="close_item"v-if="check_wishlist_user">
                        <svg class="close_item_wishlist" @click="removeItem($event, item.product_id, htmlSpecialcharsDecode(item.title))" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24">
                            <path fill="#707070" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/>
                        </svg>
                    </div>
                    <ListingItem :item="item" :whistlist="false" />
                </div>
            </div>

            <span class="listing-load-viewed" v-if="total_item > 0">
                You've viewed {{ Math.min(section.viewed, total_item) }} of {{ total_item }} Products
            </span>
            <div class="btn_return" v-else>
                <nuxt-link :to="getLangUrl('shop/', baseUrl, locale)" class="return_shop">Return To Shop</nuxt-link>
            </div>
        </div>
        <div v-show="isShowPopup" class="kts-wishlist-modal inf_remove" style="display: none;">
            <div class="kts-modal-content remove_item">
                <div class="icon_wishlist">
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path fill="#777777" d="m17.95 13.35l2.825-2.825q.3-.3.7-.3t.7.3t.3.713t-.3.712l-3.525 3.525q-.3.3-.712.3t-.713-.3l-1.4-1.425q-.3-.3-.3-.7t.3-.7t.7-.287t.7.287zm-10.125 4.8q-1.8-1.625-3.088-2.9t-2.125-2.4t-1.225-2.175T1 8.475q0-2.35 1.575-3.912T6.5 3q1.3 0 2.475.55T11 5.1q.85-1 2.025-1.55T15.5 3q2.025 0 3.4 1.138T20.775 7H18.65q-.45-1-1.325-1.5T15.5 5q-1.275 0-2.2.688T11.575 7.5h-1.15Q9.65 6.375 8.662 5.688T6.5 5q-1.425 0-2.463.988T3 8.474q0 .825.35 1.675t1.25 1.963t2.45 2.6T11 18.3q.65-.575 1.525-1.325t1.4-1.25l.225.225l.488.488l.487.487l.225.225q-.55.5-1.4 1.238t-1.5 1.312l-.775.7q-.275.275-.675.275t-.675-.275z"/></svg>
                </div>
                <span><span class="title_remove_item" v-html="htmlSpecialcharsDecode(title_product)"></span> has been removed from the wishlist.</span>
                <a class="kts-button" @click="handleClosePopup">x  Close</a>
            </div>
        </div>
        <button v-show="isLoadMore" class="listing-load-more" @click="loadMore">LOAD MORE</button>
    </div>
</template>

<style lang="scss" scoped>

    @import "@/assets/scss/components/wishlist/_listing.scss";
    .wishlist_custom {
        .listing-products {
            row-gap: 45px;
            .item_wishlist {
                .w_price {
                    padding: 0 !important;
                }
            }
        }
        .listing-load-viewed {
            margin-top: 60px;
        }
    }
    .listing-item {

    }
</style>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import type { IAPIResponseError } from '~/types/apiResponseError';
import ListingItem from "~/components/Product/ProductItem.vue";
import { getCookie } from "@/utils/cookie";
import { useCustomGtm } from '~/composables/useEventTagManager';
const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { getLangUrl } from '~/utils/getLangUrl';

const { trackRemoveWishList } = useCustomGtm();
const userStore = useUserStore();

const per_page = 12;
const isShowPopup = ref(false);
const title_product = ref('');

const emit = defineEmits<{
  (e: "onRemove", id: number): void;
}>();

const isLoadMore = ref(false);
const { $ajax } = useNuxtApp();

const props = defineProps({
    dataListing: {
        type: Array,
        default: () => [],
    },
    dataLoadMore: {
        type: Array,
        default: () => [],
    },
    check_remove: {
        type: Boolean,
        default: false
    }
});

const check_wishlist_user = ref(props.check_remove);

interface IResponse {
  success: boolean;
  data: any[];
};

const total_item = computed(() => props.dataListing.length + props.dataLoadMore.length);
const displayedSections = ref([{ items: props.dataListing.slice(0, per_page), viewed: Math.min(per_page, total_item.value) }]);
isLoadMore.value = total_item.value > per_page;

const loadMore = () => {
    const start = displayedSections.value.reduce((acc, section) => acc + section.items.length, 0);
    const end = start + per_page;
    const newItems = props.dataLoadMore.slice(start - props.dataListing.length, end - props.dataListing.length);

    if (newItems.length > 0) {
        displayedSections.value.push({
            items: newItems,
            viewed: Math.min(start + newItems.length, total_item.value),
        });
    }

    isLoadMore.value = displayedSections.value.reduce((acc, section) => acc + section.items.length, 0) < total_item.value;
};
onMounted(() => {
    const currentShareKey = getCookie("share_key_wishlist") ?? '';
    // console.log('currentShareKeycheck', currentShareKey);
    // console.log('userStore.wishlist_sharekey', userStore.user.wishlist_sharekey);
    // console.log('userStore.isLogin', userStore.isLogin);

    if(userStore.isLogin && userStore.user.wishlist_sharekey === currentShareKey){
        check_wishlist_user.value = true;
    }
})

const removeItem = (event: any, id_item: number, title: string) => {
    event.stopPropagation();
    event.preventDefault();
    title_product.value = title;
    // console.log('title',title);
    if (typeof title === 'string' && title.trim() !== '') {
        trackRemoveWishList(title);
    }

    id_item = Number(id_item);

    let list_wishlist = JSON.parse(localStorage.getItem('list_wishlist') || '[]');
    const itemIndex = list_wishlist.indexOf(id_item);
    if (itemIndex === -1) {
        // list_wishlist.push(id_item);
    } else {
        list_wishlist.splice(itemIndex, 1);
    }
    localStorage.setItem('list_wishlist', JSON.stringify(list_wishlist));
    if(check_wishlist_user){
        let all_item_wishlist = JSON.parse(localStorage.getItem('all_item_wishlist') || localStorage.getItem('list_wishlist') || '[]');
      const itemIndex = all_item_wishlist.indexOf(id_item);
      if (itemIndex === -1) {
        // all_item_wishlist.push(id_item);
      } else {
        all_item_wishlist.splice(itemIndex, 1);
      }
      localStorage.setItem('all_item_wishlist', JSON.stringify(all_item_wishlist));
    }

    isShowPopup.value = true;
    setTimeout(() => {
        isShowPopup.value = false;
    }, 4000);

    if(userStore.isLogin){
      const user_id = userStore.user.id ?? 0;
      like_item_wishlist(id_item);
    }
    else{
        like_item_wishlist(id_item);
        // console.log('action wishlist not login');
    }

    emit("onRemove", id_item);
};
const like_item_wishlist = async(id_item: Number) => {
  try {
    const response = await $ajax.get<IResponse>(`wp-json/skj/v1/wishlist/like?id_item=${id_item}`,{ headers: {"Authorization": `Bearer ${userStore.csrf}`,'X-API-Server': userStore.csrf_server} });
    if(response.success){

    }
  }catch(error) {
      if (error && typeof error === 'object' && 'data' in error) {
          const errorData = error.data as IAPIResponseError;
        //   console.log('wishlistdetailErrorCatch', errorData.code);
      } else {
          console.log('Unexpected error:', error);
      }
  }
}

const handleClosePopup = (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    isShowPopup.value = false;
    document.body.style.overflowY = 'scroll';
}


watch(
    () => [props.dataListing, props.dataLoadMore],
    ([newDataListing, newDataLoadMore]) => {
        displayedSections.value = [{ items: newDataListing.slice(0, per_page), viewed: Math.min(per_page, total_item.value) }];
        isLoadMore.value = newDataListing.length + newDataLoadMore.length > per_page;
    },
    { immediate: true, deep: true }
);

</script>